import { ApiAuthor } from './ApiAuthor'
import { ApiImage, getImageUrl } from './ApiImage'
import { ApiCategory } from './ApiCategory'
import moment from 'moment'

export interface ApiStory {
  id?: string;
  title?: string;
  slug?: string;
  publicationDate?: string;
  summary?: string;
  author?: ApiAuthor;
  featuredImage?: ApiImage;
  categories?: ApiCategory[];
  relatedStories?: ApiStory[];
  authorMultiple?: ApiAuthor[]; 
}

export const getStoryId = (story: ApiStory) => story?.id ?? ''

export const getStoryAuthor = (story: ApiStory) => story?.author ?? {}

export const getStoryTitle = (story: ApiStory)  => story?.title ?? ''

export const getStoryPublicationDate =  (story: ApiStory)  => story?.publicationDate ?? ''

export const getStoryPublicationDateMoment = (story: ApiStory) => moment(getStoryPublicationDate(story))

export const getPublicationDateForDisplay = (story: ApiStory) => `${getStoryPublicationDateMoment(story).format('MMMM')} ${getStoryPublicationDateMoment(story).format('DD')}, ${getStoryPublicationDateMoment(story).format('YYYY')}`

export const getStoryFeaturedImage = (story: ApiStory) => story?.featuredImage ?? {}

export const getStoryRelatedStories = (story: ApiStory) => story?.relatedStories ?? []

export const getStorySummary = (story: ApiStory) => story?.summary ?? ''

export const getStoryFeaturedImageUrl = (story: ApiStory) => getImageUrl(getStoryFeaturedImage(story))

export const getStorySlug = (story: ApiStory) => story?.slug ?? ''

export const getStoryCategories = (story: ApiStory) => story?.categories ?? []

export const getStoryAuthors = (story: ApiStory) => story?.authorMultiple ?? []

export const parseApiStory = (story: ApiStory): ApiStory => ({
    id: getStoryId(story),
    title: getStoryTitle(story),
    publicationDate: getStoryPublicationDate(story),
    summary: getStorySummary(story),
    author: getStoryAuthor(story),
    authorMultiple: getStoryAuthors(story), 
    slug: getStorySlug(story),
    featuredImage: getStoryFeaturedImage(story),
    relatedStories: getStoryRelatedStories(story),
    categories: getStoryCategories(story)
})